import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DimensionsListenerDirective } from '@games/shared/game-dynamic-blocks/dimensions-listener.directive';
import { CalculatorModule } from '@shared/components/games/calculator/calculator.module';
import { FractionSvgComponent } from '../fraction-svg/fraction-svg.component';
import { MathLineComponent } from '../math-line/math-line.component';
import { MathMatrixComponent } from '../math-matrix/math-matrix.component';
import { MathRootComponent } from '../math-root/math-root.component';
import { MathSubComponent } from '../math-sub/math-sub.component';
import { MathSupComponent } from '../math-sup/math-sup.component';
import { MathExpressionComponent } from './math-expression.component';

@NgModule({
  declarations: [MathExpressionComponent],
  imports: [
    CommonModule,
    DimensionsListenerDirective,
    FractionSvgComponent,
    MathLineComponent,
    MathRootComponent,
    MathSupComponent,
    MathSubComponent,
    MathMatrixComponent,
    CalculatorModule,
  ],
  exports: [
    MathExpressionComponent,
    FractionSvgComponent,
    MathLineComponent,
    MathRootComponent,
    MathSupComponent,
    MathSubComponent,
    MathMatrixComponent,
    CalculatorModule,
  ],
})
export class MathExpressionModule {}
